const usphoneRE = new RegExp('(\\+?1-?)?(\\([2-9]([02-9]\\d|1[02-9])\\)|' +
                             '[2-9]([02-9]\\d|1[02-9]))-?[2-9]\\d{2}-?\\d{4}');
const gbphoneRE = new RegExp('(?:(?:(?:00\\s?|\\+)44\\s?)|(?:\\(?0))(?:\\d{2}\\)?\\s?' +
                             '\\d{4}\\s?\\d{4}|\\d{3}\\)?\\s?\\d{3}\\s?\\d{3,4}|\\d{4}\\)?\\s?' +
                             '(?:\\d{5}|\\d{3}\\s?\\d{3})|\\d{5}\\)?\\s?\\d{4,5})');
const intphoneRE = /(?:(\+))?([0-9\-\s()])*[0-9]+/;

export function phoneNumberFormat(countryCode) {
  switch(countryCode) {
    case 'US':
    case 'CA':
      return usphoneRE;
    case 'GB':
      return gbphoneRE;
    default:
      return intphoneRE;
  }
}

export function phoneNumberMask(countryCode) {
  switch(countryCode) {
    case 'US':
    case 'CA':
      return '(999) 999-9999';
    case 'GB':
      return '99999 999 999';
  }
}

export function phoneNumberMaxLength() {
  return 15;
}
